/* eslint-disable import/no-unresolved */
import { useEffect } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Theme from "./config/Theme";
// import routes from "./config/Routes";
// import Header from "./shared/Header";
import Router from "./utils/Router";
import StorageService from "./utils/Storage/storageService";
import store from "./redux/store";
import { setUserData } from "./redux/Actions/common";
import ErrorBox from "./shared/ErrorBox";

function App() {
  useEffect(() => {
    const userData = StorageService.getFromLocalStorage("user");
    if (userData) store.dispatch(setUserData(userData));
  }, []);
  return (
    <Theme>
      <ErrorBox />
      <Router />
    </Theme>
  );
}

export default App;
